import React from 'react';
import styles from './ProductItem.module.css';

const ProductItem = ({ shelfPercentage, length, product, isCardView, fullWidth }) => {
    const percentage = shelfPercentage || (100 / length);
    const widthWithCM = (fullWidth * percentage) / 100;
    const singleProductAspectRatio = widthWithCM / product.placementDiameter;
    const sumOfProducts = parseInt(widthWithCM / product.placementDiameter);

    return (
        <div className={styles.container} style={{ width: `${percentage}%` }}>
            <div className={styles.productContainer}>
                {
                    sumOfProducts && Array.from(Array(sumOfProducts)).map(() => 
                        <img
                            src={product.imageUrl}
                            style={{
                                objectFit: 'contain',
                                width: `${100/singleProductAspectRatio}%`
                            }}
                            alt="product"
                        />
                    )
                }

            </div>

            {!isCardView && (<>

                <div className={styles.containerLength}>
                    <div className={styles.productName}>
                        {product.name}
                    </div>
                    {widthWithCM.toFixed(2)}cm<br />
                    {percentage.toFixed(1)}%
                </div>
            </>
            )}
        </div>
    );
}

export default ProductItem;